import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconContainer: {
    width: 24,
    height: 24,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  trendContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  trendIcon: {
    fontSize: 10,
  },
  trendText: {
    fontSize: 10,
    fontWeight: 400,
  },
  value: {
    fontSize: 32,
    fontWeight: 800,
    color: theme.palette.text.primary,
    lineHeight: 1,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginTop: 4,
  },
  sublabel: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
}));

type StatMetricProps = {
  value: string | number;
  label: string;
  sublabel?: string;
  trend?: {
    value: string;
    direction: 'up' | 'down';
  };
  icon?: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
};

export const StatMetric = ({
  value,
  label,
  sublabel,
  trend,
  icon,
  iconBgColor,
  iconColor,
}: StatMetricProps) => {
  const classes = useStyles();
  const trendColor = trend?.direction === 'up' ? '#22C55E' : '#EF4444';

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        {icon && (
          <Box
            className={classes.iconContainer}
            style={{ backgroundColor: iconBgColor }}
          >
            {React.cloneElement(icon as React.ReactElement, {
              style: { fontSize: 12, color: iconColor },
            })}
          </Box>
        )}
        {trend && (
          <Box className={classes.trendContainer}>
            {trend.direction === 'up' ? (
              <TrendingUpIcon
                className={classes.trendIcon}
                style={{ color: trendColor }}
              />
            ) : (
              <TrendingDownIcon
                className={classes.trendIcon}
                style={{ color: trendColor }}
              />
            )}
            <Typography
              className={classes.trendText}
              style={{ color: trendColor }}
            >
              {trend.value}
            </Typography>
          </Box>
        )}
      </Box>
      <Box>
        <Typography className={classes.value}>{value}</Typography>
        <Typography className={classes.label}>{label}</Typography>
        {sublabel && (
          <Typography className={classes.sublabel}>{sublabel}</Typography>
        )}
      </Box>
    </Box>
  );
};
